import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { 
  MdBusiness, 
  MdGavel, 
  MdLocationOn, 
  MdMonetizationOn, 
  MdVerifiedUser, 
  MdArrowForward 
} from "react-icons/md";

export default function HomeAbout() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (!ready) {
    return <div className="container mSupportLoading">{getInlineLoader()}</div>;
  }

  return (
    <section className="premium-about-section">
      {/* Decorative corporate layout lines to integrate with banner structure */}
      <div className="about-geometric-anchor" />

      <div className="container premium-about-container">
        <div className="row align-items-center">
          
          {/* LEFT SIDE: Asymmetric Metric Grid & Corporate Milestones */}
          <div className="col-lg-6 col-12 order-2 order-lg-1" data-aos="fade-right">
            <div className="about-metric-matrix">
              
              {/* Card 1: National Presence */}
              <div className="metric-pillar-card blueprint-navy mShadow2">
                <div className="pillar-icon-shield">
                  <MdLocationOn />
                </div>
                <div className="pillar-content">
                  <h3 className="pillar-stat">3 <span className="stat-unit">Hubs</span></h3>
                  <h5>National Coverage</h5>
                  <p>Strategically anchored in Dar es Salaam, Dodoma, and Morogoro serving clients nationwide.</p>
                </div>
              </div>

              {/* Card 2: Revenue Scale Capability */}
              <div className="metric-pillar-card blueprint-white mShadow2">
                <div className="pillar-icon-shield text-gold">
                  <MdBusiness />
                </div>
                <div className="pillar-content">
                  <h3 className="pillar-stat">$200M</h3>
                  <h5>Enterprise Scale</h5>
                  <p>Trusted by complex operations ranging from high-potential startups to corporations generating $200M annually.</p>
                </div>
              </div>

              {/* Card 3: Fee Structuring Advantage */}
              <div className="metric-pillar-card blueprint-white mShadow2">
                <div className="pillar-icon-shield text-navy">
                  <MdMonetizationOn />
                </div>
                <div className="pillar-content">
                  <h3 className="pillar-stat">Fixed</h3>
                  <h5>Fiscal Certainty</h5>
                  <p>Committed to predictable pricing modeling with completely transparent, fair fixed fees.</p>
                </div>
              </div>

              {/* Card 4: Compliance Status */}
              <div className="metric-pillar-card blueprint-gold mShadow2">
                <div className="pillar-icon-shield">
                  <MdGavel />
                </div>
                <div className="pillar-content">
                  <h3 className="pillar-stat">NBAA</h3>
                  <h5>Registered Firm</h5>
                  <p>Certified Public Accountants in Public Practice adhering to elite national regulatory statutory benchmarks.</p>
                </div>
              </div>

            </div>
          </div>

          {/* RIGHT SIDE: Strategic Executive Narrative Block */}
          <div className="col-lg-6 col-12 order-1 order-lg-2 mb-5 mb-lg-0" data-aos="fade-left">
            <div className="about-narrative-engine">
              
              <div className="narrative-eyebrow">
                <span className="eyebrow-line" />
                <span className="eyebrow-text">Corporate Profile Overview</span>
              </div>
              
              <h2 className="narrative-title">
                Driving Fiscal Integrity Across <span className="title-navy-highlight">Tanzania’s Commercial Landscapes</span>
              </h2>
              
              <p className="narrative-paragraph primary-lead">
                Founded by three specialized partners, Blessing Management Consultancy has evolved into 
                one of the country's fastest-growing audit and advisory member firms. We deliver premier statutory auditing, 
                advanced tax consultancy, and custom business engineering.
              </p>

              <p className="narrative-paragraph secondary-support">
                Our organizational model combines deep local compliance mastery with flexible operational reach. 
                Whether advising entities expanding across global corridors or managing localized tax frameworks, 
                our dedication remains absolute: engineered accuracy, strict professional timeline protection, 
                and exceptional client service systems that transform financial challenges into long-term strategic value.
              </p>

              {/* High-End Functional Grid Checklist */}
              <div className="narrative-distinction-grid">
                <div className="distinction-item">
                  <MdVerifiedUser className="distinction-check" />
                  <div>
                    <h6>Elite Quality Assurance</h6>
                    <p>Rigorous internal Friday technical analysis regimes ensuring flawless file execution.</p>
                  </div>
                </div>
                <div className="distinction-item">
                  <MdVerifiedUser className="distinction-check" />
                  <div>
                    <h6>Seamless Continuity</h6>
                    <p>Stable, multi-partner governance providing uninterrupted leadership over long financial cycles.</p>
                  </div>
                </div>
              </div>

              {/* Action Button Navigation Trigger */}
              <div className="narrative-action-wrapper">
                <button 
                  className="narrative-primary-btn"
                  onClick={() => appContext.navTo({ item: "profile" })}
                >
                  <span>Explore Complete Credentials</span>
                  <MdArrowForward className="action-arrow-motion" />
                </button>
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>
  );
}